export default "__VITE_ASSET__Dp72aS0W__"